import { useContext, useEffect, useState } from "react";
import { Table, Tooltip, Card } from "antd";

import { Context } from "../../context";
import { Fetch } from "../../fetch";

const { Column } = Table;

const TopContent = () => {
  const { token, apiUrl } = useContext(Context);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState([]);
  const [timeframe, _] = useState("30:days");

  useEffect(() => {
    setLoading(true);
    Fetch(`${apiUrl}/reports/top_content?limit=15`, token, (result) => {
      if (result) {
        setData(result.data);
        setRefresh(false);
        setLoading(false);
      }
    });
  }, [apiUrl, token, refresh, timeframe]);

  return (
    <div>
      <Card
        title="Top Content for the last 30 days"
        className="two-col-reports-wrapper"
      >
        <Table
          dataSource={data}
          loading={loading}
          size="small"
          pagination={{ pageSize: 10, hideOnSinglePage: true }}
        >
          <Column
            title="Content Title"
            align="left"
            dataIndex={"title"}
            render={(_, record) =>
              record.field && record.field.length > 50 ? (
                <Tooltip title={record.field}>
                  <span>{`${record.field.slice(0, 50)}...`}</span>
                </Tooltip>
              ) : (
                record.field
              )
            }
          />
          <Column title="Views" align="center" dataIndex={"views"} />
        </Table>
      </Card>
    </div>
  );
};

export default TopContent;
